import React from "react";
import Home from "../Home";
import { TranslateProvider } from "../../translate";

const HomeContainer = ({ medium, source, locale, mode }) => {
  return (
    <TranslateProvider>
      <Home medium={medium} source={source} locale={locale} mode={mode} />
    </TranslateProvider>
  );
};

export default HomeContainer;
